/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import {
  Box,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { FC, useState } from "react";

export interface SelectionItem {
  id: string;
  label: string;
}

interface MultiObjectSelectorProps {
  label?: string;
  sources: SelectionItem[];
  selected?: string[];
  disabled?: boolean;
  onSelected?: (selected: string[]) => void;
}
export const MultiObjectSelector: FC<MultiObjectSelectorProps> = ({
  label,
  sources,
  selected,
  disabled,
  onSelected,
}) => {
  const [selectedItemIds, setSelectedItemIds] = useState(selected ?? []);
  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        sx={{ width: "100%", backgroundColor: "white" }}
        size="small"
        label={label}
        value={selectedItemIds}
        multiple
        disabled={disabled}
        onChange={(e) => {
          const value =
            typeof e.target.value === "string"
              ? [e.target.value as string]
              : (e.target.value as string[]);
          setSelectedItemIds(value);
          onSelected?.(value);
        }}
        input={<OutlinedInput label="Chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
                key={value}
                label={sources.find((s) => s.id === value)?.label ?? value}
              />
            ))}
          </Box>
        )}
      >
        {sources.map((item: SelectionItem) => (
          <MenuItem key={item.id} value={item.id}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={3}>
                {item.label}
              </Grid>
            </Grid>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
